module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/training-details/psa-training/psa-training.component.css
// module id = ./src/app/pages/functions/training-details/psa-training/psa-training.component.css
// module chunks = main